// extracted by mini-css-extract-plugin
module.exports = {"table":"Readings_table__1Ript","editButton":"Readings_editButton__1gWLl","deleteButton":"Readings_deleteButton__3XiMm","readingsContainer":"Readings_readingsContainer__2lCoI"};